import React       from 'react';
import FormContext from '@widesk-ui/contexts/FormContext';

export default function useForm() {
	return React.useContext(FormContext);
}
